export default __webpack_public_path__ + "static/hacker-view-dashboard-9858a9de08d891caced857060174091f.jpg";